import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["data-dp-tooltip", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "spinner-border spinner-border-sm ms-2",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "btn btn-icon btn-danger",
    "data-dp-tooltip": _ctx.$t('delete'),
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteData && _ctx.deleteData(...args)), ["prevent"])),
    disabled: _ctx.isDeleting
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(["mas", _ctx.iconClass])
    }, "delete", 2),
    (_ctx.isDeleting)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}